import React from 'react';
import feather from 'assets/img/logos/feather-white.png';
import featherDark from 'assets/img/logos/feather-white-dark.png';
import { SpinnerContainer, Logo } from './styled';

const Spinner = ({ variant, size, className }: Props) => {
  return (
    <SpinnerContainer className={className}>
      <Logo
        src={variant === 'dark' ? featherDark : feather}
        alt="loading..."
        size={size}
      />
    </SpinnerContainer>
  );
};

type Props = {
  variant?: string;
  size?: string;
  className?: string;
};

export default Spinner;
